import { createConfigSelector } from '@americanexpress/travel-selectors';
import { TRAVELER_V2_API_URL_KEY } from '../constants/travelerDataConstants';

export const travelerV2APIBaseUrlSelector = createConfigSelector(TRAVELER_V2_API_URL_KEY);
